import { routerActions } from "connected-react-router";
import { useGetAccounts } from "hooks/useAccounts";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";
import { EcheqActions } from "pages/echeck/constants";

export const useExecuteAction = (echeqsToDoActions) => {
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { selectedAccount } = useSelector((state) => state.accounts);
    useGetAccounts();

    const executeEcheqAction = () => {
        let attribute = echeqsToDoActions.specialAttribute;

        if (echeqsToDoActions.action === "CUSTODY" || echeqsToDoActions.action === "DEPOSIT") {
            attribute = selectedAccount.uniformBankCode;
        }
        setIsSubmitting(true);
        if (
            echeqsToDoActions.action === EcheqActions.REPUDIATE ||
            echeqsToDoActions.action === EcheqActions.REPUDIATE_CESION ||
            echeqsToDoActions.action === EcheqActions.ANULATE ||
            echeqsToDoActions.action === EcheqActions.DEPOSIT ||
            echeqsToDoActions.action === EcheqActions.ADMIT ||
            echeqsToDoActions.action === EcheqActions.RESCUE
        ) {
            dispatch(
                echeckActions.executeActionEcheqTransaction({ ...echeqsToDoActions, specialAttribute: attribute }),
            );
        } else {
            dispatch(echeckActions.executeActionEcheq({ ...echeqsToDoActions, specialAttribute: attribute }));
        }
    };

    useEffect(() => {
        if (!echeqsToDoActions.action) {
            dispatch(routerActions.goBack());
        }
        return () => {
            dispatch(echeckActions.cleanEcheqAction());
        };
    }, [dispatch]);

    return { isSubmitting, executeEcheqAction };
};

export default useExecuteAction;
